/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Badge, Button, ErrorText, KV, PageHeader, Spinner } from '@/components/ui';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { fmtDate } from '@/lib/format';

const ED: Record<string, string> = { BASE: 'Базовая', LAWYER: 'Юрист', BANKRUPTCY: 'Банкротство' };

export function LicensePage() {
  const qc = useQueryClient();
  const { reload } = useAuth();
  const { data } = useQuery({ queryKey: ['license'], queryFn: () => api.get('/license') });
  const install = useMutation({
    mutationFn: async (f: File) => api.post('/license', JSON.parse(await f.text())),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['license'] }); reload(); },
  });
  if (!data) return <Spinner />;
  const p = data.payload;
  return (
    <>
      <PageHeader title="Лицензия" actions={<label className="cursor-pointer"><span className="inline-flex rounded-md bg-brand-600 px-3.5 py-1.5 text-sm font-medium text-white hover:bg-brand-700">Загрузить файл лицензии</span>
        <input type="file" accept=".json" className="hidden" onChange={(e) => e.target.files?.[0] && install.mutate(e.target.files[0])} /></label>} />
      <ErrorText error={install.error} />
      <div className="card mb-5 p-4">
        {p ? <KV items={[['Лицензиат', p.licensee], ['ИНН', p.inn], ['Редакция', ED[p.edition]], ['Пакет ИИ', p.aiPackage ? 'да' : 'нет'],
          ['Пользователей', p.maxUsers], ['Срок', p.validTo >= '2099-01-01' ? `бессрочно с ${fmtDate(p.validFrom)}` : `${fmtDate(p.validFrom)} - ${fmtDate(p.validTo)}`], ['Обновления и поддержка', p.updatesTo ? `до ${fmtDate(p.updatesTo)}` : 'не указано'], ['Статус', data.valid ? <Badge tone="green">действует</Badge> : <Badge tone="red">не действует</Badge>]]} />
          : <div className="text-sm">{data.devMode ? 'Лицензия не загружена: работает режим разработки, все модули включены.' : 'Лицензия не загружена.'}</div>}
      </div>
      <div className="card overflow-x-auto">
        <table className="w-full">
          <thead className="bg-slate-50"><tr><th className="th">Код</th><th className="th">Модуль</th><th className="th">Состояние</th></tr></thead>
          <tbody>{data.catalog.map((m: any) => (
            <tr key={m.code} className="border-t border-slate-100"><td className="td tabular-nums">{m.code}</td><td className="td">{m.name}</td>
              <td className="td">{data.modules.includes(m.code) ? <Badge tone="green">включён</Badge> : <Badge>не входит</Badge>}</td></tr>
          ))}</tbody>
        </table>
      </div>
    </>
  );
}
